import HOOK from "../../../components/hooks"
import { BASE, CATEGORY, MAX, RADIO, TAB } from "../../../modules/constants"
import { getNameProp } from "../../../modules/utilities"

export const getSecondLevelIdsList = props => {
    // Returns a list of ids from a subset of the 1st level connections
    // console.log('getSecondLevelIdsList props:', props)
    // Get the connection Ids for the hub entity
    var idsList = []
    if (scndLvlCheckboxChecked(props) && props.nexusData.nodes.length > 0) {

        var { connectionIds } = props.nexusData.nodes[0].entity
        const sortedEntities = getSortedEntities({ ...props, connectionIds })
        for (let index = 0; index < Math.min(sortedEntities.length, MAX.SECOND_LEVEL); index++) {
            let entity = sortedEntities[index]

            // Add ids of un-acquired entities to idsList
            if (!entity.acquired && !entity.pageNotFound) {
                // console.log('entity:',entity)
                idsList.push({ ids: entity.ids.join(','), name: getNameProp.toPresent(entity.name) })
            }
        }
    }
    return idsList
}

export const scndLvlCheckboxChecked = props => props.tabIndex === TAB[BASE.COMPANY].INDEX
    ? props.radio[BASE.COMPANY] === RADIO[BASE.COMPANY].CONNECTIONS
    : props.radio[BASE.PERSON] === RADIO[BASE.PERSON].CONNECTIONS

const sortByCategory = entities =>
    entities.sort(a => a.category === CATEGORY.COMPANY ? 1 : -1)

const getSortedEntities = ({ entities, checkboxes, connectionIds }) => {
    // Returns a list of entities with connections corresponing to the current tense checkboxes
    let filteredEntities = [] // entities

    for (var key in connectionIds) {
        let connection = entities.connections[connectionIds[key]]
        let entity = entities.items[key]

        if (!!(checkboxes[HOOK.TENSE] & connection.connections.tenseBits))
            filteredEntities.push(entity)
    }

    return sortByCategory(filteredEntities);
}
